import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=2963b2c0&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=js&"
export * from "./choose.vue?vue&type=script&lang=js&"
import style0 from "./choose.vue?vue&type=style&index=0&id=2963b2c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963b2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2963b2c0')) {
      api.createRecord('2963b2c0', component.options)
    } else {
      api.reload('2963b2c0', component.options)
    }
    module.hot.accept("./choose.vue?vue&type=template&id=2963b2c0&scoped=true&", function () {
      api.rerender('2963b2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xmy/drawer/choose.vue"
export default component.exports